"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.printSupplyBeet = exports.isPrintSupplyUnlimited = exports.isPrintSupplyLimited = exports.isPrintSupplyZero = void 0;
const beet = __importStar(require("@metaplex-foundation/beet"));
const isPrintSupplyZero = (x) => x.__kind === 'Zero';
exports.isPrintSupplyZero = isPrintSupplyZero;
const isPrintSupplyLimited = (x) => x.__kind === 'Limited';
exports.isPrintSupplyLimited = isPrintSupplyLimited;
const isPrintSupplyUnlimited = (x) => x.__kind === 'Unlimited';
exports.isPrintSupplyUnlimited = isPrintSupplyUnlimited;
exports.printSupplyBeet = beet.dataEnum([
    ['Zero', beet.unit],
    [
        'Limited',
        new beet.BeetArgsStruct([['fields', beet.fixedSizeTuple([beet.u64])]], 'PrintSupplyRecord["Limited"]'),
    ],
    ['Unlimited', beet.unit],
]);
//# sourceMappingURL=PrintSupply.js.map